import React from "react";
import {
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "reactstrap";
import { FaXTwitter } from "react-icons/fa6";
import { FaTiktok, FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";
import "./BannerStyle.scss";

import { useTranslation } from "react-i18next";
const contactImg = require("../../../Assets/Images/canva/canvaContact.png");
const CanvaContact = () => {
  let { t } = useTranslation();
  return (
    <section id="canvaContact" className="BannerImgTen" >
         <Container fluid className="h-100" >
        <Row className="h-100 align-items-center">
          <Col lg={6} md={6} className="">
            <Card className="text-center mx-3 border-0  border border-primary h-100">
              <CardHeader
                style={{ backgroundColor: `#4E9463` }}
                className="border-0 p-3"
              >
                <h1 className="nomrateFont text-center mb-0 display-6"   style={{ letterSpacing: "3px", position: "relative" }}>Contact Us</h1>
              </CardHeader>
              <CardBody className="p-0">
                <div className="ms-3 p-3">
                  <h5 className="nomrateFont text-start mb-0">Phone</h5>
                  <h5 className="nomrateFont text-start mb-0">+1(617) 716-9723</h5>
                </div>
                <div
                  className="w-100 py-1 my-1"
                  style={{ borderBottom: "1px solid #B9EB88", height: "1px" }}
                ></div>
                <div className="ms-3 p-3">
                  <h5 className="nomrateFont text-start mb-0">Email</h5>
                  <h5 className="nomrateFont text-start mb-3">info@easytipping.com</h5>
                </div>
              </CardBody>
              <CardFooter
                className="p-3"
                style={{ backgroundColor: `#B9EB88`, border:"1px solid #ccc666" }}
              >
                <Row className="justify-content-between align-items-center px-1">
                  <Col md={4}>
                    <h4 className="nomrateFont mb-0 text-start ms-2">Follow Us</h4>
                  </Col>

                  <Col md={8}
                    className="logos fw-bold text-dark px-4"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      fontSize: "32px",
                      gap: "14px",
                      color: "black",
                    }}
                  >
                    <a
                      target="blank"
                      href="https://www.tiktok.com/@easytippingapp"
                      style={{ color: "black" }}
                    >
                      <FaTiktok />
                    </a>
                    <a
                      target="blank"
                      href="https://twitter.com/EasytippingApp"
                      style={{ color: "black" }}
                    >
                      <FaXTwitter />
                    </a>
                    <a
                      target="blank"
                      href="https://www.instagram.com/easytippingapp/?utm_source=ig_web_button_share_sheet&igshid=OGQ5ZDc2ODk2ZA=="
                      style={{ color: "black" }}
                    >
                      <FaInstagram />
                    </a>
                    <a
                      target="blank"
                      href="https://www.facebook.com/profile.php?id=61551375382911"
                      style={{ color: "black" }}
                    >
                      <FaFacebookF />
                    </a>
                    <a
                      target="blank"
                      href="https://www.youtube.com/@EasyTippingApp"
                      style={{ color: "black" }}
                    >
                      <FaYoutube />
                    </a>
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} sm={12}>
            <div className="w-100 text-center p-3">
              <img className="img-fluid w-75" src={contactImg} alt="" />
            </div>
          </Col>
        </Row>
      </Container>

    </section>
   
 
  );
};

export default CanvaContact;
